import React from 'react';
import {BarLoader} from "react-spinners";
import BackgroundPhoto from '../BackgroundPhoto';

export default function Loader() {

  return (
    <BackgroundPhoto>
      <h4 style={{color: "#000000", marginBottom: 30}}>Please wait</h4>
      <BarLoader
          // css={override}
          // size={160}
          height={7}
          color={"#000000"}
          // loading={this.state.loading}
      />
    </BackgroundPhoto>
  );
}